import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import {
    Box,
    DaTable,
    DaTableBody,
    DaTableHeadCell,
    DaTableHead,
    Text,
} from '@paygreen/paygreen-ui';
import MemoizedRow from './MemoizedRow';

const SectorsDaTable = ({
    t,
    data,
    isLoading,
    headerGroups,
    page,
    prepareRow,
    userSector,
    updateUserSector,
}) => (
    <Box>
        <DaTable
            blockWidth="none"
            isLoading={isLoading}
            loadingRowNumber={15}
            loadingMainCellNumber={3}
        >
            {headerGroups.map((headerGroup) => (
                <DaTableHead
                    blockTitle={t('user.list.table.title')}
                    {...headerGroup.getHeaderGroupProps()}
                >
                    {headerGroup.headers.map((column, index) => (
                        <DaTableHeadCell
                            key={index}
                            label={column.render('Header')}
                        >
                            {index === 0 ? column.render('Filter') : null}
                        </DaTableHeadCell>
                    ))}
                </DaTableHead>
            ))}

            <DaTableBody>
                {!isLoading && data.length && page.length ? (
                    page.map((row) => {
                        prepareRow(row);

                        return (
                            <MemoizedRow
                                key={row.id}
                                row={row}
                                className="DaTableRow"
                                updateUserSector={updateUserSector}
                                userSector={userSector}
                                {...row.getRowProps()}
                            />
                        );
                    })
                ) : (
                    <Text
                        align="center"
                        marginTop="xl"
                        marginBottom="xl"
                        textSize="sm"
                    >
                        {t('noDataFound')}
                    </Text>
                )}
            </DaTableBody>
        </DaTable>
    </Box>
);

SectorsDaTable.propTypes = {
    data: PropTypes.array.isRequired,
    isLoading: PropTypes.bool,
    headerGroups: PropTypes.array.isRequired,
    page: PropTypes.array.isRequired,
    prepareRow: PropTypes.func.isRequired,
    userSector: PropTypes.object,
    updateUserSector: PropTypes.func,
};

SectorsDaTable.defaultProps = {
    isLoading: false,
};

export default withTranslation('common')(SectorsDaTable);
